import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { adminApi } from "@/lib/api";

const FIELDS = [
  ["google_ads_pct", "google-ads", "Google ADV"], ["data_pct", "data", "Costo report SU"], ["meta_ai_pct", "meta-ai", "Meta ai"],
  ["tiktok_pct", "tiktok", "TikTok"], ["scraping_web_pct", "scraping-web", "Scaping Web"], ["mail_massive_pct", "mail-massive", "Mail massive"],
];

const Field = ({ id, label, value, onChange }) => (
  <label className="flex items-center gap-2 text-xs">
    <span className="text-[#5b6168] whitespace-nowrap">{label}</span>
    <Input data-testid={`pct-${id}-input`} type="number" min="0" max="100" step="0.5" value={value} onChange={(e) => onChange(e.target.value)}
      className="h-8 w-20 bg-[#f4f6f7] border-[#d5dbde] rounded-sm font-mono text-xs" />
    <span className="text-[#5b6168]">%</span>
  </label>
);

export const PctSettings = ({ settings, onSaved }) => {
  const [vals, setVals] = useState(settings);
  useEffect(() => setVals(settings), [settings]);
  const total = FIELDS.reduce((a, [k]) => a + (Number(vals[k]) || 0), 0);
  const save = () => adminApi.setCostSettings(Object.fromEntries(FIELDS.map(([k]) => [k, Number(vals[k]) || 0])))
    .then(() => { toast.success("Percentuali salvate"); onSaved(); })
    .catch(() => toast.error("Valori non validi (0–100)"));
  return (
    <div data-testid="pct-settings" className="border border-[#d5dbde] bg-white px-4 py-3 space-y-2">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
        <span className="text-[10px] uppercase tracking-widest font-mono text-[#6b7280]">Calcolo margine</span>
        {FIELDS.map(([k, id, label]) => <Field key={k} id={id} label={label} value={vals[k] ?? 0} onChange={(v) => setVals((p) => ({ ...p, [k]: v }))} />)}
        <button data-testid="pct-save-btn" onClick={save}
          className="h-8 px-3 text-[11px] border border-[#2B3036] hover:bg-[#2B3036] hover:text-white transition-colors rounded-sm">Salva</button>
      </div>
      <p className="text-[10px] text-[#6b7280]">
        Percentuali sul prezzo pagato, usate come valore di default per ogni campagna (modificabile riga per riga).
        Con 0% TikTok usa il costo reale Apify e Scaping Web il costo reale Google Places + Perplexity.
        Totale costi: <b data-testid="pct-total" className={total > 100 ? "text-[#E0262C]" : "text-[#2B3036]"}>{total}%</b> · margine di default {Math.max(0, 100 - total)}%
      </p>
    </div>
  );
};
